import * as yup from 'yup';

import { propertyContractBaseSchema } from '@/features/Contract/Property/contractBaseSchema';
import { locales } from '@/features/validation/locales';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

yup.setLocale(locales);

export const contractSchema = propertyContractBaseSchema;

export type ContractStore = yup.Asserts<typeof contractSchema>;

export const usePhvContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'PhvContractStore',
);
